module.exports = __webpack_public_path__ + "img/LR-LIFETAKT_einzelne-produkte_1-HINTERGRUND.b827492b.jpg";